export default __webpack_public_path__ + "static/media/tale05.31af9946.png";